import React, { Fragment, useState } from "react";
import { withTranslation } from "react-i18next";
import styled from "styled-components";
import moment from "moment";
import packageJson from "../../../package.json";
import { 
  Button, 
  Collapse, 
  Card, 
  CardHeader, 
  CardBody, 
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem
} from "reactstrap";
import BootstrapTable from 'react-bootstrap-table-next';
import '../../scss/custom_.css'
import { axiosGet } from "../../helper/fetch";
import EventDetails from './EventDetails';

const Footer = styled.div`
  position: absolute;
  bottom: 0;
  height: 70px;
  justify-content: flex-end;
  width: calc(100% - 230px);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
`;

const Line = styled.div`
  position: relative;
  width: 100%;
  border: 1px solid #808489;
`;

const Dashboard = ({ t }) => {
  const date = moment(new Date()).format("DD/MM/YYYY");
  const [isCollapseOpen, setCollapseIsOpen] = useState(false);
  const [selected, setSelected] = useState({});
  const [loading, setLoading] = useState(true);
  const [eventList, setEventList] = useState([]);
  //const [dropdownOpen, setDropdownOpen] = useState(false);
  //const [days, setDays] = useState(30);

  const [fromDate, setFromDate] = useState(() => {
    const d = new Date();
    d.setDate(d.getDate() - 10); // por defecto: últimos 10 días
    return d.toISOString().slice(0,10); // 'YYYY-MM-DD'
  });
  const [toDate, setToDate] = useState(() => {
    const d = new Date();
    return d.toISOString().slice(0,10); // 'YYYY-MM-DD'
  });

  // valida que from <= to (ambas strings 'YYYY-MM-DD')
  const isRangeValid = fromDate && toDate && fromDate <= toDate;

  //const toggle = () => setDropdownOpen((prevState) => !prevState);

  const toggleCollapse = async () => {
    setCollapseIsOpen(!isCollapseOpen);
    if(!isCollapseOpen){
      await loadEventAuditsByDate(fromDate, toDate);
      setLoading(false);
    }
  };

  /* const loadEventAudits = async(auditdays) => {
    const res = await axiosGet(`api/events/get-events/${auditdays}`, 'GET')
    setEventList(res.data);
  } */

  const loadEventAuditsByDate = async (from, to) => {
  const res = await axiosGet('api/events/get-events', 'GET', {
    from, // 'YYYY-MM-DD'
    to,   // 'YYYY-MM-DD'
  });
  setEventList(res.data);
};

  const headerSortingStyle = { backgroundColor: '#343b41' };

  const columns = [
    {
      dataField: 'eventAudit',
      text: 'ID',
      sort: true,
      headerSortingStyle,
      headerStyle: { width: '100px' },   // ancho fijo de cabecera
      style: { width: '100px' }, 
    },
    {
      dataField: 'eventDate',
      text: t("Events.date"),
      sort: true,
      formatter: (cell) => new Date(cell).toLocaleString(),
      headerStyle: { width: '200px' },   // ancho fijo de cabecera
      style: { width: '200px' }, 
      headerSortingStyle,
    },
    {
      dataField: 'loginName',
      text: t("Events.userName"),
      sort: true,
      headerSortingStyle,
      headerStyle: { width: '200px' },   // ancho fijo de cabecera
      style: { width: '200px' }, 
    },
    {
      dataField: 'additional',
      text: t("Events.desc"),
      sort: true,
      headerSortingStyle,
    }, 
  ];

  const handleRowSelect = (row) => {
    setSelected({
      id: row.eventaudit,
      date: row.eventDate,
      userName: row.loginName,
      description: row.Additional,
    })
  };

  const selectRow = {
    mode: 'radio',
    clickToSelect: true,
    bgColor: '#23282c',
    hideSelectColumn: true,
    selected: [selected.id],
    onSelect: handleRowSelect,
  };

  const expandRow = {
    renderer: row => (
      <div>
        <EventDetails eventaudit={row.eventAudit}/>
      </div>
    ),
    showExpandColumn: true,
    onlyOneExpanding: true,
    expandColumnPosition: "right",
    expandHeaderColumnRenderer: ({ isAnyExpands }) => {
      if (isAnyExpands) {
        return <i className="fa fa-search-minus" aria-hidden="true" style={{ color: '#fc5f38' }}></i>;
      }
      return <i className="fa fa-search-plus" aria-hidden="true"></i>;
    },
    expandColumnRenderer: ({ expanded }) => {
      if (expanded) {
        return (
          <i className="fa fa-search-minus" aria-hidden="true" style={{ color: '#fc5f38' }}></i>
        );
      }
      return (
        <i className="fa fa-search-plus" aria-hidden="true"></i>
      );
    }
  };

  /* const handleDaysChange = async(e) => {
    setDays(e.target.value)
    setLoading(true);
    await loadEventAudits(e.target.value);
    setLoading(false);
  }; */

  return (
    <Fragment>
      <div>
        <h2>{t("Dashboard.welcome")}</h2>
        <Button onClick={toggleCollapse} style={{ marginBottom: '1rem' }}>{t("Dashboard.activityBtn")}</Button>
        <Collapse isOpen={isCollapseOpen}>
          <Card>
            <CardHeader>
              <div className="d-flex align-items-center gap-3 flex-wrap">
                <div className="d-flex align-items-center gap-2 mr-2">
                  <label className="mb-0">{t("Dashboard.from")}</label>
                  <input
                    type="date"
                    value={fromDate}
                    max={toDate || undefined}
                    onChange={(e) => setFromDate(e.target.value)}
                    className="form-control form-control-sm"
                    style={{ width: 170 }}
                  />
                </div>

                <div className="d-flex align-items-center gap-2 mr-2">
                  <label className="mb-0">{t("Dashboard.to")}</label>
                  <input
                    type="date"
                    value={toDate}
                    min={fromDate || undefined}
                    onChange={(e) => setToDate(e.target.value)}
                    className="form-control form-control-sm"
                    style={{ width: 170 }}
                  />
                </div>
                <button
                  className="btn btn-sm btn-primary"
                  disabled={!isRangeValid || loading}
                  onClick={async () => {
                    if (!isRangeValid) return;
                    setLoading(true);
                    try {
                      await loadEventAuditsByDate(fromDate, toDate);
                    } finally {
                      setLoading(false);
                    }
                  }}
                >
                  {loading ? 'Cargando...' : 'Consultar'}
                </button>
              </div>
            </CardHeader>
            <CardBody>
              {
                loading
                ? (
                  <div style={{height: '400px'}} className='d-flex justify-content-center align-items-center'>
                    <i data-testid="spinner" className="fa fa-circle-o-notch fa-5x fa-spin" aria-hidden="true"></i>
                  </div>
                )
                : (
                  <div className="custom-scroll" style={{ height: '50vh', display:'block',  overflow: 'scroll'}}>
                    {
                      eventList.length > 0 ?
                      (
                        <BootstrapTable
                          keyField='eventAudit'
                          data={ eventList }
                          columns={ columns }
                          selectRow={selectRow}
                          expandRow={ expandRow }
                          bordered={false}
                          hover
                          striped
                          classes='custom-table-width'
                        />
                      ) : (
                        <div className='d-flex flex-column justify-content-center align-items-center w-100 h-100'>
                          <i className="fa fa-inbox fa-4x"></i>
                          <h3>{t("Dashboard.noResults")}</h3>
                        </div>
                      )
                    }
                    
                  </div>
                )
              }
            </CardBody>
          </Card>
        </Collapse>
      </div>

      <Footer>
        <Line />
        <div>
          <h3>Delsat Group S.A</h3>
        </div>
        <div>
          <h5>{`${date} - ${packageJson.version}`}</h5>
        </div>
      </Footer>
    </Fragment>
  );
};

export default withTranslation()(Dashboard);
